import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { PaginationState } from '../panel-hub/models/pagination-state';
import { DefaultPaginationConfiguration } from '../panel-hub/models/pagination-config';
import { PaginatorState } from '../models/paginator-state';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [CommonModule, PaginatorModule],
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatorComponent {
  @Input() totalRecords: number = 0;
  @Input() currentPage: number = 1;
  @Input() pageSize: number = DefaultPaginationConfiguration.defaultPageSize;
  @Input() pageSizeOptions: number[] = DefaultPaginationConfiguration.availablePageSizes;
  @Output() pageChange = new EventEmitter<PaginationState>();
  get totalPages(): number {
    const size = this.pageSize || DefaultPaginationConfiguration.defaultPageSize;
    if (size <= 0) return 0;
    return Math.max(0, Math.ceil((this.totalRecords || 0) / size));
  }

  get currentPageNumber(): number {
    return this.currentPage === 0 ? this.currentPage + 1 : this.currentPage;
  }

  firstIndex = 0;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentPage']) {
      const size = (this.pageSize && this.pageSize > 0) ? this.pageSize : DefaultPaginationConfiguration.defaultPageSize;
      const page = (this.currentPage && this.currentPage > 0) ? this.currentPage : 1;
      this.firstIndex = Math.max(0, (page - 1) * size);
    }
  }

  onPageChange(event: PaginatorState): void {
    this.pageSize = event.rows ?? this.pageSize;

    this.pageChange.emit({
      pageNumber: (event.page ?? 0) + 1,
      pageSize: this.pageSize ?? DefaultPaginationConfiguration.defaultPageSize,
      totalRecords: this.totalRecords
    });
  }

}
